/**
 * Monkey-patch react-router's history wrapper
 * (https://github.com/ReactTraining/history) to automatically track the depth
 * of the "in-app" location stack via location.state. This lets us build an
 * in-app back button that only shows up if the back button would take you back
 * to a previous screen *of the app*, rather than to an external website.
 *
 * We track this through location.state, rather than just keeping it in-memory,
 * so we can track it through page refreshes or opening/closing the browser.
 */
export default function patchInAppHistoryState(browserHistory) {
  const { push } = browserHistory;

  browserHistory.push = (path, state = {}) => {
    // get current location state
    const currentState = browserHistory.location.state;

    let inAppHistoryStackLength = 1;
    if (currentState && currentState.inAppHistoryStackLength) {
      inAppHistoryStackLength = currentState.inAppHistoryStackLength + 1;
    }

    // XXX: `path` can either be a string pathname, or a "location-like object"
    // that already includes state. if it's the latter, we append the stack
    // state to path.state; if it's the former, we use the second argument of
    // `push()` to push state
    //
    // thx history for the warning:
    // https://github.com/ReactTraining/history/blob/197c76e/modules/createBrowserHistory.js?1534690004244#L162
    if (path && path.state) {
      push({ ...path, state: { ...path.state, inAppHistoryStackLength } });
    } else {
      push(path, {
        ...state,
        inAppHistoryStackLength,
      });
    }
  };
}
